import React from "react";
import { toast } from "sonner";

// Mostra le ultime 6 cifre dell'ID tecnico (clic per copiare l'ID completo)
export const IdBadge = ({ id, className = "text-[10px]" }) => {
  if (!id) return null;
  const full = String(id);
  const short = full.slice(-6);
  const copy = (e) => {
    e.stopPropagation();
    try { navigator.clipboard?.writeText(full); toast.success(`ID copiato: ${full}`); }
    catch { toast.message(`ID: ${full}`); }
  };
  return (
    <button type="button" onClick={copy} data-testid={`id-badge-${id}`} title={`ID: ${full} · clicca per copiare`}
      className={`leading-none text-muted-foreground font-mono hover:text-foreground transition-colors ${className}`}>
      ID #{short}
    </button>
  );
};

export default IdBadge;
